import CourseCard from "./CourseCard";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

// Sample courses data - will be replaced with real data from backend
const courses = [
  {
    id: "1",
    title: "Complete Digital Marketing Masterclass",
    instructor: "Adaobi Okafor",
    thumbnail: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    duration: "12 hours",
    students: 2340,
    rating: 4.8,
    category: "Marketing",
  },
  {
    id: "2",
    title: "Web Development Bootcamp 2024",
    instructor: "Chinedu Eze",
    thumbnail: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80",
    duration: "24 hours",
    students: 4521,
    rating: 4.9,
    category: "Development",
  },
  {
    id: "3",
    title: "Financial Literacy & Investment",
    instructor: "Funmi Adeyemi",
    thumbnail: "https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?w=800&q=80",
    duration: "8 hours",
    students: 1890,
    rating: 4.7,
    category: "Finance",
  },
  {
    id: "4",
    title: "Graphic Design Fundamentals",
    instructor: "Emeka Nwosu",
    thumbnail: "https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&q=80",
    duration: "16 hours",
    students: 3210,
    rating: 4.8,
    category: "Design",
  },
  {
    id: "5",
    title: "Business & Entrepreneurship",
    instructor: "Ngozi Obi",
    thumbnail: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
    duration: "10 hours",
    students: 2780,
    rating: 4.6,
    category: "Business",
  },
  {
    id: "6",
    title: "Data Analysis with Excel & Python",
    instructor: "Olumide Bakare",
    thumbnail: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    duration: "14 hours",
    students: 1560,
    rating: 4.9,
    category: "Data",
  },
];

interface CourseGridProps {
  showAll?: boolean;
}

const CourseGrid = ({ showAll = false }: CourseGridProps) => {
  const displayedCourses = showAll ? courses : courses.slice(0, 6);

  return (
    <section className="py-32 bg-muted/30">
      <div className="container">
        {/* Section Header */}
        {!showAll && (
          <div className="text-center mb-16">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-5">
              Popular Courses
            </h2>
            <p className="text-muted-foreground text-lg max-w-lg mx-auto">
              Start building in-demand skills today with our expert-led courses.
            </p>
          </div>
        )}

        {/* Grid */}
        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {displayedCourses.map((course, index) => (
            <div
              key={course.id}
              className="animate-fade-up"
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              <CourseCard {...course} />
            </div>
          ))}
        </div>

        {/* View All */}
        {!showAll && (
          <div className="text-center mt-14">
            <Link to="/courses">
              <Button variant="outline" size="lg">
                View All Courses
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default CourseGrid;
